var map = {
	"./AutomationTestingProcess-1.png": 146,
	"./applications.png": 147,
	"./fig-testing-process.svg": 148,
	"./iPad-Application-meridian-uae.jpg": 149,
	"./responsive-design.jpg": 150,
	"./security.jpg": 151,
	"./web.jpg": 152,
	"./webdesign.jpg": 153,
	"./webdev.jpg": 154,
	"./write.jpg": 155
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72;